const steps = [
  {
    id: 1,
    title: "Neem contact met ons op.",
    descriptions: [
      { method: "Telefonisch", description: "Bel ons direct voor een snelle en persoonlijke reactie." },
      { method: "Per mail", description: "Stuur ons een e-mail en wij zullen zo spoedig mogelijk reageren." },
      { method: "Website", description: "Vul het contactformulier in op onze website voor een snelle digitale connectie." },
    ]
  },
  {
    id: 2,
    title: "Wij contacteren u",
    descriptions: [
      { method: "Wij vragen de nodige info", description: "We nemen contact op om de benodigde informatie te verzamelen voor een beter begrip van uw behoeften." },
      { method: "Wij plannen een afspraak in", description: "Na het verkrijgen van de vereiste gegevens, plannen we een afspraak in voor verdere bespreking." },
    ]
  },
  {
    id: 3,
    title: "Ik kom tot bij u.",
    descriptions: [
      { method: "Bespreking", description: "Tijdens ons bezoek bespreken we uw wensen en beantwoorden we eventuele vragen." },
      { method: "Opmeten", description: "We voeren nauwkeurige metingen uit om ervoor te zorgen dat alles perfect past." },
      { method: "Advies", description: "We bieden professioneel advies op maat van uw situatie en behoeften." },
    ]
  },
  {
    id: 4,
    title: "De offerte",
    descriptions: [
      { method: "Opmaak offerte", description: "Op basis van de bespreking en metingen stellen we een gedetailleerde offerte op." },
      { method: "Prijs calculatie", description: "We geven transparante informatie over de prijsopbouw en eventuele bijkomende kosten." },
      { method: "Opbellen voor akkoord", description: "We nemen contact op om de offerte door te nemen en uw akkoord te verkrijgen voor verdere stappen." },
    ]
  },
];

export default steps;

